/* Copyright (c) 2026 - Svayam Infoware Pvt. Ltd. All rights reserved. */
import { AppModule } from '../../core/rbac/rbac.policy';

/** Sidebar child under the Administration folder. */
export interface AdminNavItem {
  label: string;
  path: string;
  module: AppModule;
  icon: 'gear' | 'shield' | 'docs';
}

/**
 * Admin catalog screens nested under “Administration”.
 * Parent folder is shown only when at least one child passes canModule().
 */
export const ADMINISTRATION_NAV_ITEMS: readonly AdminNavItem[] = [
  { label: 'User management', path: '/settings', module: 'settings', icon: 'gear' },
  { label: 'Roles & permissions', path: '/roles', module: 'roles', icon: 'shield' },
  { label: 'Resources', path: '/resources', module: 'roles', icon: 'docs' },
] as const;

export function filterAdminNavItems(
  canModule: (module: AppModule) => boolean,
): AdminNavItem[] {
  return ADMINISTRATION_NAV_ITEMS.filter((item) => canModule(item.module));
}
